// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"155":"c83a6d55","211":"dccd2f71","277":"9265004a","286":"116f831b","293":"a4ced4fe","379":"457b47e3","492":"84568e3a","495":"58955071","698":"3de7a2c5","724":"101efc78","821":"17f17277"}[chunkId] + ".js";
};